import React from 'react';
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import axios from '~/data/http/axios'
import DateTimeFunctions from '~/Classes/dateTimeFunctions';
import NumberFunctions from '~/Classes/numberFormatFunctions'
import i18n from '~/i18n'

export default class AddEvent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            eventName: "",
            error: ""
        }
        this.save = this.save.bind(this);
    }

    componentDidMount() {

    }

    async save() {
        if (this.state.eventName.length < 4) {
            return this.setState({ error: "Please enter a longer event name" })
        }
        try {
            await axios.post('/accountMaster/tracker/events', { name: this.state.eventName })
            this.props.close();
        }
        catch (err) {
            let error = "There was a problem adding this event type, please try again"
            if (err && err.data && err.data.error) error = err.data.error;
            this.setState({ error })
        }
    }

    render() {
        return <>
            <h4 className="mar-b10">Add a new Event</h4>
            <div className="mar-b25">Please enter a name for your new event type</div>
            <TextInput error={this.state.error} className="mar-b25" placeholder="Event name; ie Registration" value={this.state.eventName} onChange={(ev) => { this.setState({ eventName: ev.target.value }) }} />
            <Button text="Continue" iconRight={<Icons icon="arrowRight" />} disabled={this.state.eventName.length < 4} onClick={this.save} />
        </>
    }
}
